import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfficialService {
  private httpClient = inject(HttpClient);

  constructor() { }

  indexTournament(_tournamentId) {
    return this.httpClient.get<any>('api_endpoint' + `/tournament/${_tournamentId}/official/index`).pipe(
      map(res => res.data)
    );
  }

  addToTournament(_tournamentId: string, phone: string, _userId: string) {
    return this.httpClient.post<any>('api_endpoint' + `/tournament/${_tournamentId}/official/add`, { phone, _userId }).pipe(
      map(res => res.data)
    );
  }

  removeFromTournament(_tournamentId, _userId) {
    return this.httpClient.post<any>('api_endpoint' + `/tournament/${_tournamentId}/official/remove`, { _userId }).pipe(
      map(res => res.data)
    );
  }

  setAvailability(_tournamentId: string, _userId: string, isAvailable: boolean) {
    return this.httpClient.post<any>('api_endpoint' + `/tournament/${_tournamentId}/official/set-availability`, { _userId, isAvailable }).pipe(
      map(res => res.data)
    );
  }

  setVenue(_tournamentId: string, _officialId: string, _venueId: boolean): Observable<{ success: boolean }> {
    return this.httpClient.post<any>('api_endpoint' + `/tournament/${_tournamentId}/official/set-venue`, { _officialId, _venueId }).pipe(
      map(res => res.data)
    );
  }

  removeOfficialFromMatch(_matchId: string, _officialId: string, _userId: string, _tournamentId: string) {
    return this.httpClient.put<any>('api_endpoint' + `/match/${_matchId}/remove-official`, { _officialId, _userId, _tournamentId }).pipe(
      map(res => res.data)
    );
  }
}
